(function() {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }
    callback();
  }

  function updateCartCount(cart) {
    document.querySelectorAll('.CartCount, .cart-count, [data-cart-count]').forEach(function(node) {
      node.textContent = cart.item_count;
      node.classList.remove('hidden-count');
    });
    syncDrawerActions(cart);
  }

  function syncDrawerActions(cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !cart) return;

    var fallback = drawer.querySelector('[data-bae-cart-drawer-actions]');
    if (!fallback) return;

    var hasItems = cart.item_count > 0;
    var renderedFooter = drawer.querySelector('#CartContainer .ajaxcart__footer');
    var renderedCheckout = renderedFooter && renderedFooter.querySelector('.Checkout');
    var renderedCartView = renderedFooter && renderedFooter.querySelector('.cart__cartview');
    var hasRenderedActions = renderedCheckout && renderedCartView;
    var mobileViewport = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    var renderedActionsVisible = mobileViewport &&
      hasRenderedActions &&
      isVisibleInViewport(renderedCheckout) &&
      isVisibleInViewport(renderedCartView);

    fallback.hidden = !hasItems || (!!hasRenderedActions && (!mobileViewport || renderedActionsVisible));
    fallback.setAttribute('aria-hidden', fallback.hidden ? 'true' : 'false');
  }

  function isVisibleInViewport(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < window.innerHeight &&
      rect.left < window.innerWidth;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.money_format) {
      return window.Shopify.formatMoney(cents, window.money_format);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function normalizeEmptyCartPage() {
    if (window.location.pathname !== '/cart') return;

    var popup = document.getElementById('empty-cart--popup');
    if (!popup) return;

    var overlay = document.getElementById('empty-cart--overlay');
    if (overlay) overlay.remove();

    var closeButton = popup.querySelector('.close-cart-empty');
    if (closeButton) closeButton.remove();

    popup.style.position = 'static';
    popup.style.zIndex = 'auto';
    popup.style.transform = 'none';
    popup.style.width = '100%';
    popup.style.maxWidth = '640px';
    popup.style.margin = '0 auto 24px';

    document.documentElement.classList.remove('fixx');
    document.body.classList.remove('fixx', 'modal-open');
    document.body.style.overflow = '';
  }

  function updateVisibleCart(line, quantity, cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var row = drawer.querySelector('.all-products-details[data-line="' + line + '"]');
    if (row && quantity === 0) {
      row.remove();
    } else if (row) {
      var item = cart.items[parseInt(line, 10) - 1];
      var input = row.querySelector('.ajaxcart__qty-num');
      var price = row.querySelector('.price .money, h4.price .money');

      if (input) input.value = quantity;
      if (price && item) price.textContent = formatMoney(item.line_price);
      row.classList.remove('is-loading', 'is-removed');
    }

    var total = drawer.querySelector('.side-cart--total .money');
    if (total) total.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      var container = drawer.querySelector('#CartContainer');
      if (container) container.innerHTML = '<p class="cart-empty-text">Your cart is currently empty.</p>';
    }

    syncDrawerActions(cart);
  }

  function updateVisibleCartPage(line, quantity, cart) {
    var cartForm = document.getElementById('cart_form');
    if (!cartForm) return;

    var row = cartForm.querySelector('.all-products-details[data-line="' + line + '"]');
    if (row && quantity === 0) {
      window.location.href = '/cart';
      return;
    }

    if (row) {
      var item = cart.items[parseInt(line, 10) - 1];
      var displayedQuantity = item ? item.quantity : quantity;
      var input = row.querySelector('.cart-quantity-input');
      if (input) input.value = displayedQuantity;
      row.classList.remove('is-loading', 'is-removed');
    }

    var total = cartForm.querySelector('.cart-total--price .money');
    if (total) total.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      normalizeEmptyCartPage();
      window.location.href = '/cart';
    }
  }

  function reloadCartDrawer() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
      return;
    }

    if (window.ShopifyAPI && typeof window.ShopifyAPI.getCart === 'function') {
      window.ShopifyAPI.getCart(function(cart) {
        updateCartCount(cart);
        syncDrawerActions(cart);
      });
    }
  }

  function changeCartLine(line, quantity) {
    var body = new URLSearchParams();
    body.set('line', line);
    body.set('quantity', quantity);

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: body.toString()
    }).then(function(response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    });
  }

  function handleCartClick(event) {
    var quantityButton = event.target.closest('.ajaxcart__qty-adjust');
    var removeButton = event.target.closest('.ajaxcart_remove');
    var target = quantityButton || removeButton;

    if (!target || !target.closest('#CartDrawer')) return;

    var line = target.getAttribute('data-line');
    if (!line) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var row = target.closest('.all-products-details');
    var quantityInput = row ? row.querySelector('.ajaxcart__qty-num') : null;
    var quantity = 0;

    if (quantityButton && quantityInput) {
      quantity = parseInt(quantityInput.value.replace(/\D/g, ''), 10);
      if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
      quantity += quantityButton.classList.contains('ajaxcart__qty--plus') ? 1 : -1;
      if (quantity < 0) quantity = 0;
      quantityInput.value = quantity;
    }

    if (row) row.classList.add(quantity === 0 ? 'is-removed' : 'is-loading');

    changeCartLine(line, quantity)
      .then(function(cart) {
        updateCartCount(cart);
        updateVisibleCart(line, quantity, cart);
        if (quantity === 0) window.setTimeout(reloadCartDrawer, 50);
      })
      .catch(function() {
        if (row) row.classList.remove('is-loading', 'is-removed');
      })
      .finally(function() {
        if (row) {
          window.setTimeout(function() {
            row.classList.remove('is-loading');
          }, 400);
        }
      });
  }

  function handleCartPageClick(event) {
    var addButton = event.target.closest('#cart_form .cart-quantity-add');
    var removeButton = event.target.closest('#cart_form .cart-quantity-remove');
    var removeLink = event.target.closest('#cart_form .cart__remove[data-line]');
    var target = addButton || removeButton || removeLink;

    if (!target) return;

    var line = target.getAttribute('data-line');
    if (!line) {
      var rowForLine = target.closest('.all-products-details');
      line = rowForLine ? rowForLine.getAttribute('data-line') : '';
    }
    if (!line) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var row = target.closest('.all-products-details');
    var quantityInput = row ? row.querySelector('.cart-quantity-input') : null;
    var quantity = 0;

    if (!removeLink && quantityInput) {
      quantity = parseInt(quantityInput.value.replace(/\D/g, ''), 10);
      if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
      quantity += addButton ? 1 : -1;
      if (quantity < 1) quantity = 1;
      quantityInput.value = quantity;
    }

    if (row) row.classList.add(removeLink ? 'is-removed' : 'is-loading');

    changeCartLine(line, quantity)
      .then(function(cart) {
        updateCartCount(cart);
        updateVisibleCartPage(line, quantity, cart);
      })
      .catch(function() {
        if (row) row.classList.remove('is-loading', 'is-removed');
      })
      .finally(function() {
        if (row && quantity !== 0) {
          window.setTimeout(function() {
            row.classList.remove('is-loading');
          }, 400);
        }
      });
  }

  function handleCartInput(event) {
    var input = event.target.closest('#CartDrawer .ajaxcart__qty-num');
    if (!input) return;

    var line = input.getAttribute('data-line');
    if (!line) return;

    var quantity = parseInt(input.value.replace(/\D/g, ''), 10);
    if (!Number.isFinite(quantity) || quantity < 0) quantity = 1;
    input.value = quantity;

    var row = input.closest('.all-products-details');
    if (row) row.classList.add(quantity === 0 ? 'is-removed' : 'is-loading');

    changeCartLine(line, quantity)
      .then(function(cart) {
        updateCartCount(cart);
        updateVisibleCart(line, quantity, cart);
        if (quantity === 0) window.setTimeout(reloadCartDrawer, 50);
      })
      .catch(function() {
        if (row) row.classList.remove('is-loading', 'is-removed');
      })
      .finally(function() {
        if (row) {
          window.setTimeout(function() {
            row.classList.remove('is-loading');
          }, 400);
        }
      });
  }

  function handleCartPageInput(event) {
    var input = event.target.closest('#cart_form .cart-quantity-input');
    if (!input) return;

    var line = input.getAttribute('data-line');
    if (!line) return;

    var quantity = parseInt(input.value.replace(/\D/g, ''), 10);
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
    input.value = quantity;

    var row = input.closest('.all-products-details');
    if (row) row.classList.add('is-loading');

    changeCartLine(line, quantity)
      .then(function(cart) {
        updateCartCount(cart);
        updateVisibleCartPage(line, quantity, cart);
      })
      .catch(function() {
        if (row) row.classList.remove('is-loading');
      })
      .finally(function() {
        if (row) {
          window.setTimeout(function() {
            row.classList.remove('is-loading');
          }, 400);
        }
      });
  }

  function escapeValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return value.replace(/"/g, '\\"');
  }

  function getSortLabel(value) {
    var desktopOption = document.querySelector('#SortBy option[value="' + escapeValue(value) + '"]');
    if (desktopOption) return desktopOption.textContent.trim();

    var mobileOption = document.querySelector('.js-sort-by[data-value="' + escapeValue(value) + '"]');
    return mobileOption ? mobileOption.textContent.trim() : '';
  }

  function currentSortValue() {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get('sort_by');
    if (fromUrl) return fromUrl;

    var desktopSelect = document.querySelector('#SortBy');
    if (desktopSelect && desktopSelect.value) return desktopSelect.value;

    var selectedOption = document.querySelector('#SortBy option[selected]');
    return selectedOption ? selectedOption.value : '';
  }

  function syncMobileSort() {
    var value = currentSortValue();
    if (!value) return;

    document.querySelectorAll('.collection-page__mobile-sort').forEach(function(wrapper) {
      var items = wrapper.querySelectorAll('.js-sort-by');
      if (!items.length) return;

      var label = getSortLabel(value);
      var toggle = wrapper.querySelector('.js-sort-toggle');
      if (toggle && label) {
        toggle.textContent = label;
        toggle.setAttribute('data-current-sort', value);
      }

      items.forEach(function(item) {
        var selected = item.getAttribute('data-value') === value;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    });
  }

  function handleSortClick(event) {
    var item = event.target.closest('.js-sort-by');
    if (!item) return;

    var value = item.getAttribute('data-value');
    if (!value) return;

    event.preventDefault();

    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function submitCartToCheckout() {
    var form = document.createElement('form');
    var checkout = document.createElement('input');

    form.method = 'post';
    form.action = '/cart';
    checkout.type = 'hidden';
    checkout.name = 'checkout';
    checkout.value = 'Checkout';
    form.appendChild(checkout);
    document.body.appendChild(form);
    form.submit();
  }

  function handleCheckoutClick(event) {
    var link = event.target.closest('a.Checkout, a.cart__checkout');
    var button = event.target.closest('[data-bae-checkout-submit]');
    var cartButton = event.target.closest('#CartDrawer button.Checkout, #CartDrawer button[name="checkout"], #cart_form button[name="checkout"]');
    var target = link || button;
    if (!target && !cartButton) return;

    var href = target ? target.getAttribute('href') || '' : '';
    if (!button && !cartButton && href.indexOf('/checkout') === -1) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    submitCartToCheckout();
  }

  function syncDrawerActionsFromCart() {
    fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    }).then(function(response) {
      if (!response.ok) throw new Error('Cart lookup failed');
      return response.json();
    }).then(function(cart) {
      updateCartCount(cart);
      syncDrawerActions(cart);
    }).catch(function() {});
  }

  function isMobileCartViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function routeMobileCartToCartPage(event) {
    if (!isMobileCartViewport()) return;

    var opener = event.target.closest('.js-drawer-open-right, [aria-controls="CartDrawer"]');
    var cartLink = event.target.closest('a[href="/cart"], a[href$="/cart"]');
    var drawerCartLink = cartLink && (cartLink.closest('.site-header, .mobile-header, header') || cartLink.querySelector('.CartCount, .cart-count, [data-cart-count]'));

    if (!opener && !drawerCartLink) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    window.location.href = '/cart';
  }

  function watchDrawerActions() {
    var container = document.getElementById('CartContainer');
    if (container && window.MutationObserver) {
      var observer = new MutationObserver(syncDrawerActionsFromCart);
      observer.observe(container, { childList: true, subtree: true });
    }

    document.addEventListener('click', function(event) {
      if (event.target.closest('.js-drawer-open-right, [aria-controls="CartDrawer"]')) {
        window.setTimeout(syncDrawerActionsFromCart, 80);
      }
    }, true);

    window.addEventListener('resize', syncDrawerActionsFromCart);
  }

  ready(function() {
    normalizeEmptyCartPage();
    syncMobileSort();
    syncDrawerActionsFromCart();
    watchDrawerActions();
    document.addEventListener('click', routeMobileCartToCartPage, true);
    document.addEventListener('click', handleCartClick, true);
    document.addEventListener('click', handleCartPageClick, true);
    document.addEventListener('change', handleCartInput, true);
    document.addEventListener('change', handleCartPageInput, true);
    document.addEventListener('click', handleSortClick, true);
    document.addEventListener('click', handleCheckoutClick, true);
  });
})();
